
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipient/[[...slug]]",
      function () {
        return require("private-next-pages/recipient/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipient/[[...slug]]"])
      });
    }
  